(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["slideshow"] && !Shopify.designMode) return;
  try {
    // <slideshow-component> custom HTML Element
  class SlideshowComponent extends HTMLElement {
    constructor() {
      super();

      this.nextSlide = this.nextSlide.bind(this);
      this.prevSlide = this.prevSlide.bind(this);
      this.intervalId = setInterval(this.nextSlide, 5000);

      this.slideIndex = 0;
    }
    connectedCallback() {
      if (this.hasChildNodes()) {
        this.querySelector('.slides').children[0].classList.add('active');
      }
      this.querySelector('.previous').addEventListener("click", this.prevSlide);
      this.querySelector('.next').addEventListener("click", this.nextSlide);
    }
    disconnectedCallback() {
      this.querySelector('.previous').removeEventListener("click", this.prevSlide);
      this.querySelector('.next').removeEventListener("click", this.nextSlide);
    }
    nextSlide() {
      clearInterval(this.intervalId);

      if (this.slideIndex == (this.querySelector('.slides').children.length - 1)) {
        this.slideIndex = 0;
      } else {
        this.slideIndex++;
      }
      for (let i = 0; i < this.querySelector('.slides').children.length; i++) {
        this.querySelector('.slides').children[i].classList.remove('active');
      }
      this.querySelector('.slides').children[this.slideIndex].classList.add('active');

      this.intervalId = setInterval(this.nextSlide, 5000);
    }
    prevSlide() {
      clearInterval(this.intervalId);

      if (this.slideIndex == 0) {
        this.slideIndex = this.querySelector('.slides').children.length - 1;
      } else {
        this.slideIndex--;
      }
      for (let i = 0; i < this.querySelector('.slides').children.length; i++) {
        this.querySelector('.slides').children[i].classList.remove('active');
      }
      this.querySelector('.slides').children[this.slideIndex].classList.add('active');

      this.intervalId = setInterval(this.nextSlide, 5000);
    }
  }
  customElements.define('slideshow-component', SlideshowComponent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["text"] && !Shopify.designMode) return;
  try {
    // <accent-color> custom HTML Element
  class AccentColor extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
    }
    disconnectedCallback() {
    }
  }
  customElements.define('accent-color', AccentColor);
  } catch(e) { console.error(e); }
})();

})();
